import React from 'react';

import { TemplateField } from '../../../_shared/_types';
import FieldTypeDisplay from 'views/App/Portal/PerformanceReporting/_components/FieldInputs/FieldTypeDisplay';

interface TemplateFieldPreviewProps {
  field: TemplateField;
}

const TemplateFieldPreview: React.FC<TemplateFieldPreviewProps> = ({ field }) => {
  return (
    <FieldTypeDisplay
      field={field}
      disabled={true}
      isBuilderCard={false}
      size='medium'
    />
  );
};

export default TemplateFieldPreview;
